import { DateFormatter } from '@repo/toolkit/date'

import { MissionTypeEnum } from '../../types/enums/mission/mission-type.enum'
import { TransportTypeEnum } from '../../types/enums/trip/trip-type.enum'
import { TripStepTypeEnum } from '../../types/enums/trip-bookings/trip-step-type.enum'
import { TripStepTypes } from '../../types/models/trip-booking/trip-step'

export const transformTripStepsFilterToUrl = (filters?: TripStepTypes.Filter): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.type !== undefined) searchParams.append('type', filters.type.toString())
  if (filters.departureDate) searchParams.append('departureDate', filters.departureDate)
  if (filters.transportType !== undefined)
    searchParams.append('transportType', filters.transportType.toString())
  if (filters.missionType && filters.missionType.length)
    searchParams.append('missionType', filters.missionType.join(','))
  if (filters.transportMean) searchParams.append('transportMean', filters.transportMean)
  if (filters.meetingPlaceIds && filters.meetingPlaceIds.length)
    searchParams.append('meetingPlaceIds', filters.meetingPlaceIds.join(','))

  return searchParams.toString()
}

export const transformUrlToTripStepsFilter = (
  searchParams: URLSearchParams
): TripStepTypes.Filter => {
  const filters: TripStepTypes.Filter = {
    grouped: true
  }

  const type = searchParams.get('type')
  if (type) filters.type = type as TripStepTypeEnum

  const departureDate = DateFormatter.checkDateFormat(searchParams.get('departureDate'))
  if (departureDate) filters.departureDate = departureDate

  const transportType = searchParams.get('transportType')
  if (transportType) filters.transportType = transportType as TransportTypeEnum

  const missionType = searchParams.get('missionType')
  if (missionType) filters.missionType = missionType.split(',') as MissionTypeEnum[]

  const transportMean = searchParams.get('transportMean')
  if (transportMean) filters.transportMean = transportMean

  const meetingPlaceIds = searchParams.get('meetingPlaceIds')
  if (meetingPlaceIds)
    filters.meetingPlaceIds = meetingPlaceIds.split(',').map((id) => parseInt(id, 10))

  return filters
}
